import React, { useState, useEffect } from "react";
import Layout from "../shared/Layout";
import { Toaster, toast } from "react-hot-toast";
import DataTable from 'react-data-table-component';
import { useNavigate } from 'react-router-dom';
import { createShipment, getProductOrderDetail, updatePaymentResponse } from "../../_services";
import { handleExport } from "../../_services/excelExportService";
import axios from "axios";
import { API_URL, baseurl, projectNo } from "../../_config";

const Orderlist = () => {
    // const [paymentResponse, setPaymentResponse] = useState([]);
    const navigate = useNavigate();
    const [isFormopen, setIsFormopen] = useState(false);
    const [loading, setLoading] = useState(false);
    const [productOrderData, setProductOrderData] = useState([]);
    // const [shiproketData, setShiproketData] = useState([]);
    const [shrijaOrderId, setShrijaOrderId] = useState('');
    const [activeButton, setActiveButton] = useState('all');
    const [formData, setFormData] = useState({
        order_id: shrijaOrderId,
        breadth: 0,
        height: 0,
        length: 0,
        weight: 0,
    });

    const handleButtonClick = (status) => {
        setActiveButton(status);
    };

    const fetchProductOrderDetail = async () => {
        try {
            const data = await getProductOrderDetail();
            if (data.isSuccess === 200) {
                setProductOrderData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                })
            }
        } catch (error) {
            setProductOrderData([]);
        }
    };

    useEffect(() => {
        fetchProductOrderDetail();
    }, []);

    const onShiproket = (orderId) => {
        setShrijaOrderId(orderId);
        setIsFormopen(true);
    }

    const onUpdatePaymentRes = async (id) => {
        try {
            const data = await updatePaymentResponse(id);
            if (data.data.orderStatusId != null && data.data.orderStatusId === 3) {
                // setPaymentResponse(data?.data);
                fetchProductOrderDetail();
            } else {
                console.log("Failed to payment");
            }
        }
        catch {
            console.log("Failed to payment");
        } finally {
            setLoading(false);
            fetchProductOrderDetail();
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setFormData((prevState) => ({
            ...prevState,
            [name]:
                type === 'checkbox'
                    ? checked
                    : value === ''
                        ? ''
                        : isNaN(value)
                            ? value
                            : parseFloat(value),
        }));
    };

    const onCreateShipment = async (e) => {
        e.preventDefault();
        const isConfirmed = window.confirm("Are you sure! you want to create shipment?");

        // If the user clicks "Cancel", exit the function
        if (!isConfirmed) {
            return;
        }

        // Update order_id based on the current shrisetuOrderId
        const updatedFormData = {
            ...formData,
            order_id: shrijaOrderId || 0
        };

        setLoading(true);
        try {
            const data = await createShipment(updatedFormData);
            if (data.isSuccess === 200) {
                fetchProductOrderDetail();
                toast.success("Shipment Created Successfully");
                setFormData({
                    order_id: 0,
                    breadth: 0,
                    height: 0,
                    length: 0,
                    weight: 0
                });
                setIsFormopen(false);
            }
        } catch (error) {
            toast.error("Shipment Created failed");
        }
        finally {
            setLoading(false);
        }
    };

    const onClose = () => {
        setFormData({
            order_id: 0,
            breadth: 0,
            height: 0,
            length: 0,
            weight: 0,
        });
        setIsFormopen(false);
        setShrijaOrderId(0);
    }

    // Filter orders based on the active button
    const filteredOrders = productOrderData.filter(item => {
        if (activeButton === 'success') {
            return item.orderStatusId === 3 || item.orderStatusId === 5;
        }
        else if (activeButton === 'pending') {
            return item.orderStatusId === 1;
        }
        else if (activeButton === 'failed') {
            return item.orderStatusId === 4;
        }
        else if (activeButton === 'all') {
            return productOrderData;
        }
        else if (activeButton === 'confirmed') {
            return !item.orderStatusId;
        }
        else if (activeButton === 'packaging') {
            return !item.orderStatusId;
        }
        else if (activeButton === 'outfordelivery') {
            return !item.orderStatusId;
        }
        else if (activeButton === 'delivered') {
            return !item.orderStatusId;
        }
        else if (activeButton === 'returned') {
            return !item.orderStatusId;
        }
        else if (activeButton === 'canceled') {
            return item.cancelStatus === "Y";
        }
        return true;
    });


    const excelSheetData = filteredOrders.map((item, index) => ({
        Index: index + 1,
        OrderNo: item.orderNo,
        Name: item.name,
        EmailId: item.emailId,
        MobileNo: item.mobileNo,
        OrderAmount: item.orderAmount,
        PaymentMethod: item.paymentGatewayName,
        OrderStatusType: item?.orderStatusType,
        ShippingAddress: item?.shippingAddress
    }));

    const onCustomerOrderDetail = (item) => {
        navigate(`/order-details/${item.orderId}`)
    }

    const IsExchange = async (id) => {
        try {
            const response = await axios.get(`${baseurl}${API_URL?.IsExchangeProductOrderById}`, {
                params: {
                    pProductOrderId: id,
                    pIsExchange: true,
                }
            });
            if (response.status === 200 && response.data.isSuccess === 200) {
                toast.success("Update Successfully");
                fetchProductOrderDetail();
            } else {
                toast.error("Update Failed");
            }
        } catch (error) {
            toast.error("Update Failed");
        }
    }

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Order Details',
            cell: row => (
                <div onClick={() => onCustomerOrderDetail(row)} className="order_details cursor-pointer">
                    <span className="order_number">{row.orderNo}</span>
                    <p>{row.orderDate}</p>
                </div>
            ),
            selector: row => row.orderNo,
            sortable: false,
            width: '250px',
        },
        {
            name: 'Customer Details',
            cell: row => (
                <div className="mt-2">
                    <h6 className="mb-1">{row.name}</h6>
                    <p className="mb-1">{row.emailId}</p>
                    <p>{row.mobileNo}</p>
                </div>
            ),
            sortable: false,
            width: '250px'
        },
        {
            name: 'Payment',
            cell: row => (
                <div>
                    <h6>₹{row.orderAmount}</h6>
                    <p className="pay_method_tab">{row.paymentGatewayName}</p>
                </div>
            ),
            sortable: false
        },
        {
            name: 'Status',
            cell: row => (
                <div className="d-flex patment_status_check">
                    <span className={row.orderStatusId === 3 ? "order_success" : ""}>
                        {row.orderStatusType}
                    </span>
                    {row.orderStatusId === 1 && (
                        <button className="check_status" style={{ paddingLeft: '10px' }} onClick={() => onUpdatePaymentRes(row?.orderReqId)}>
                            Check Status
                        </button>
                    )}
                </div>
            ),
            sortable: false,
            width: '250px',
        },
        {
            name: 'Shipping Details',
            cell: row => (
                <div className="d-flex patment_status_check">
                    <p>{row.shippingAddress}</p>
                </div>
            ),
            sortable: false,
            width: '250px'
        },
        ...(projectNo === 'Lifecode'
            ? [{
                name: 'IsExchange',
                selector: row => (
                    <span
                        onClick={() => IsExchange(row.orderId)}
                        style={{ cursor: 'pointer' }}
                    >
                        {row.deliveryStatus === 'Y' ? <span className="isExchange">Yes</span> : <span className="notIsExchange">No</span>}
                    </span>
                ),
                sortable: false,
                minWidth: "100px"
            }]
            : []),
        {
            name: 'Action(Create Shipment)',
            cell: row => (
                <>
                    <div className="d-flex" style={{ gap: "10px" }}>
                        <span className="edit_icon_wepper" title='view' onClick={() => onCustomerOrderDetail(row)}>
                            <i className="fas fa-eye"></i>
                        </span>
                        <span className="delete_icon_weepr" title='invoice'>
                            <i className="fa fa-download" style={{ fontSize: "16px" }}></i>
                        </span>
                    </div>
                    <div className="d-flex" style={{ gap: "10px", marginLeft: '10px' }}>
                        {(row.orderStatusId === 3 || row.orderStatusId === 5) && row.isShipStatus === "Y" ? (
                            <span>Yes</span>
                        ) : (
                            (row.orderStatusId === 3 || row.orderStatusId === 5) && (
                                <span title='Create Shipment' onClick={() => onShiproket(row.orderId)}>
                                    <svg id="Layer_1" viewBox="0 0 512 512" width="18" height="18" xmlns="http://www.w3.org/2000/svg">
                                        <g transform="matrix(1,0,0,1,0,0)">
                                            <path d="m41.3 512c-22.8 0-41.3-18.5-41.3-41.3 0-2.6.2-5.2.7-7.7l27.3-144.8c1.5-8.2 5.5-15.7 11.4-21.5l274-274c14.7-14.7 35.1-22.7 57.7-22.7 8.1 0 16.1 1 24 2.8 25.5 5.9 51.1 20.7 72.2 41.8s36 46.7 41.8 72.2c7.4 31.9.2 61.7-19.8 81.7l-274 274c-5.9 5.9-13.4 9.8-21.5 11.4l-144.8 27.4c-2.5.5-5.1.7-7.7.7zm51.8-93.1 72.9-13.8 182-182-59.1-59.1-182 182zm313.3-254.2 23.1-23.1c.2-5.4-3.8-21.8-20.6-38.5-10.1-10.2-22-17.4-32.4-19.8-1.8-.4-3.7-.7-5.5-.7h-.7l-23 23z" fill="#526484" />
                                            <path d="m499.4 119.1c-5.4-23.7-19.4-47.6-39.1-67.4s-43.8-33.7-67.4-39.1c-28.5-6.6-54.9-.4-72.3 17.1l-274 274c-4.5 4.4-7.5 10.1-8.7 16.3l-27.4 144.9c-3.2 17 8 33.4 24.9 36.6 1.9.4 3.9.5 5.8.5s3.9-.2 5.8-.5l145-27.4c6.2-1.2 11.9-4.2 16.3-8.6l274-274c17.5-17.5 23.7-43.9 17.1-72.4zm-328.5 295.3-90.3 17 17-90.3 191.3-191.3 73.3 73.3zm267.2-267.2-31.7 31.7-73.2-73.3 31.7-31.7c1-1 5.6-2.3 14-.4 12.2 2.8 25.8 11 37.2 22.4 23.5 23.7 25.6 47.7 22 51.3z" fill="url(#gradient1)" />
                                            <defs>
                                                <linearGradient id="gradient1" x1="0%" y1="0%" x2="100%" y2="100%">
                                                    <stop offset="0%" stopColor="#526484" />
                                                    <stop offset="100%" stopColor="#0063ff" />
                                                </linearGradient>
                                            </defs>
                                        </g>
                                    </svg>
                                </span>
                            )
                        )}
                    </div></>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <Toaster position="top-right" />
            <div className="px-4">
                <div className="admin-page mt-3 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading" style={{ gap: "20px" }}>
                        <h4 className="mb-0">Order List</h4>
                    </div>
                </div>
                <div className="d-flex justify-content-between">
                    <div className="filter_status_button mt-3 mb-2">
                        <button
                            className={`status_filter ${activeButton === 'all' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('all')}
                        >
                            All
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'success' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('success')}
                        >
                            Success
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'pending' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('pending')}
                        >
                            Pending
                        </button>
                        <button
                            className={`status_filter ${activeButton === 'failed' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('failed')}
                        >
                            Failed
                        </button>
                        {/* <button
                        className={`status_filter ${activeButton === 'confirmed' ? 'active' : ''}`}
                        onClick={() => handleButtonClick('confirmed')}
                    >
                        Confirmed
                    </button>
                    <button
                        className={`status_filter ${activeButton === 'packaging' ? 'active' : ''}`}
                        onClick={() => handleButtonClick('packaging')}
                    >
                        Packaging
                    </button>
                    <button
                        className={`status_filter ${activeButton === 'outfordelivery' ? 'active' : ''}`}
                        onClick={() => handleButtonClick('outfordelivery')}
                    >
                        Out for delivery
                    </button>
                    <button
                        className={`status_filter ${activeButton === 'delivered' ? 'active' : ''}`}
                        onClick={() => handleButtonClick('delivered')}
                    >
                        Delivered
                    </button>
                    <button
                        className={`status_filter ${activeButton === 'returned' ? 'active' : ''}`}
                        onClick={() => handleButtonClick('returned')}
                    >
                        Returned
                    </button>*/}
                        <button
                            className={`status_filter ${activeButton === 'canceled' ? 'active' : ''}`}
                            onClick={() => handleButtonClick('canceled')}
                        >
                            Canceled
                        </button>
                    </div>
                    <button className="export_button" onClick={() => handleExport(excelSheetData)}><img src="./images/upload.png" alt="" className="export_icon" /><span>Export</span></button>
                </div>
                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredOrders || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>


                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={onClose} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Product Package Detail for Create Shipment</h4>
                        </div>
                        <div>Ex : Product Box Size</div>
                        <form onSubmit={onCreateShipment}>
                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Product Breadth</label>
                                <input type="text" className="form-control" id="breadth" name="breadth" placeholder="Product Breadth" value={formData.breadth === 0 ? '' : formData.breadth} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Display Height</label>
                                <input type="text" className="form-control" id="height" name="height" placeholder="Display Height" value={formData.height === 0 ? '' : formData.height} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Display Length</label>
                                <input type="text" className="form-control" id="length" name="length" placeholder="Display Length" value={formData.length === 0 ? '' : formData.length} onChange={handleChange} />
                            </div>
                            <div className="form-group">
                                <label htmlFor="exampleFormControlInput1">Display Weight</label>
                                <input type="text" className="form-control" id="weight" name="weight" placeholder="Display Weight" value={formData.weight === 0 ? '' : formData.weight} onChange={handleChange} />
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button type="submit">Submit</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default Orderlist;